import { Styles, css, extractTransition, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: hidden;
    padding: 12px;
    border: 1px solid ${theme.colors.neutral.variant[20]};
    border-radius: 14px;
  `,
  title: css`
    display: flex;
    align-items: center;
    gap: 4px;
  `,
  message: css`
    display: block;
  `,
  messageSubject: ({ theme }) => css`
    color: ${theme.colors.neutral.variant[80]};
    line-height: 155%;
    font-size: 13px;
    font-family: arial, sans-serif;
  `,
  messageBody: ({ theme }) => css`
    color: ${theme.colors.neutral.variant[80]};
    line-height: 155%;
    font-size: 13px;
    font-family: arial, sans-serif;
  `,
  messageSignature: ({ theme }) => css`
    color: ${theme.colors.neutral.variant[80]};
    line-height: 155%;
    font-size: 13px;
    font-family: arial, sans-serif;
  `,
  pill: css`
    align-self: flex-start;
  `,
  showMoreRoot: css`
    max-width: 100%;
  `,
  showMoreContainer: css`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  `,
  showMoreButton: ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 2px 8px;
    border-radius: 14px;
    cursor: pointer;

    ${extractTransition((f) => f.cubic, { property: ['color', 'background'], duration: 220 })}

    &:hover {
      color: ${theme.colors.primary.fuchsia[60]};
      background: ${theme.colors.neutral.variant[10]};
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
